import User from "./User" ;
import ListWrapper from "../utils/ListWrapper" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;
import CollectionUtils from "../utils/CollectionUtils" ;


  export default  class  DomineOwner extends  DBObject {  private static readonly _HANDLINGDOMINES: number = 0 ;
  private static readonly _SALESUSER: number = 1 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _salesUser: User = null ;
  private _handlingDomines: Array<string> = ListWrapper.primitive(this,'handlingDomines',DomineOwner._HANDLINGDOMINES) ;
 public constructor ( d3eParams ? : Partial<{handlingDomines: Array<string>, salesUser: User}> ) {
 super();

this.setHandlingDomines(d3eParams?.handlingDomines ?? ListWrapper.primitive(this,'handlingDomines',DomineOwner._HANDLINGDOMINES));

this.setSalesUser(d3eParams?.salesUser ?? null);
 }
  public get d3eType (  ) : string {
 return 'DomineOwner' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get salesUser (  ) : User {
 return this._salesUser ; 
 }
  public setSalesUser ( val : User ) : void {
 let isValChanged :boolean=this._salesUser !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(DomineOwner._SALESUSER,this._salesUser);

this.updateObservable('salesUser',this._salesUser,val);

this._salesUser=val;

this.fire('salesUser',this);
 }
  public get handlingDomines (  ) : Array<string> {
 return this._handlingDomines ; 
 }
  public setHandlingDomines ( val : Array<string> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this._handlingDomines,val);

if ( !isValChanged ) {
 return ; 
 }

if ( !this.d3eChanges.contains(DomineOwner._HANDLINGDOMINES) ) {
 let _old :Array<string>=Array.from(this._handlingDomines);

this.updateD3EChanges(DomineOwner._HANDLINGDOMINES,_old);
 }

this._handlingDomines.clear();

this._handlingDomines.addAll(val);

this.fire('handlingDomines',this);
 }
  public addToHandlingDomines ( val : string,index : number = -1 ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(DomineOwner._HANDLINGDOMINES);

if ( _isNewChange ) {
 _old=Array.from(this._handlingDomines);
 }

if ( index === -1 ) {
 if ( !this._handlingDomines.contains(val) ) this._handlingDomines.add(val);
 }
 else {
 this._handlingDomines.remove(this._handlingDomines.elementAt(index));

this._handlingDomines.add(val);
 }

this.fire('handlingDomines',this,val,true);

if ( _isNewChange ) {
 this.updateD3EChanges(DomineOwner._HANDLINGDOMINES,_old);
 }
 }
  public removeFromHandlingDomines ( val : string ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(DomineOwner._HANDLINGDOMINES);

if ( _isNewChange ) {
 _old=Array.from(this._handlingDomines);
 }

this._handlingDomines.remove(val);

this.fire('handlingDomines',this,val,false);

if ( _isNewChange ) {
 this.updateD3EChanges(DomineOwner._HANDLINGDOMINES,_old);
 }
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case DomineOwner._SALESUSER : {
 return this._salesUser ; 
 }

case DomineOwner._HANDLINGDOMINES : {
 return this._handlingDomines ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : DomineOwner {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :DomineOwner=( dbObj as DomineOwner );

obj.id=this.id;

obj.setSalesUser(this._salesUser);

obj.setHandlingDomines(this._handlingDomines);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case DomineOwner._SALESUSER : {
 this.setSalesUser(( value as User ));
 break; }

case DomineOwner._HANDLINGDOMINES : {
 this.setHandlingDomines(( value as Array<any> ).cast<string>().toList());
 break; }
 }
 }
 }